import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { getInstrumentationKey } from './envVals';

const instrumentationKey = getInstrumentationKey();

let appInsights: ApplicationInsights | null = null;

if (instrumentationKey) {
    appInsights = new ApplicationInsights({
        config: {
            instrumentationKey,
            enableAutoRouteTracking: true,
            loggingLevelConsole: 2, // Verbose logging, to help debug
            disableExceptionTracking: false,
            disableCorrelationHeaders: true,
        }
    });
    appInsights.loadAppInsights();
} else {
    console.warn('Instrumentation key is undefined or null; ApplicationInsights not loaded.');
}

export default appInsights;